import React, { useCallback } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';

import Box from '@mui/material/Box';

import BackButton from '@ts-core/components/BackButton';

import { useThreads } from '@ts-core/hooks/forum';

import NewThreadForm from '@ts-core/components/Forum/ThreadForm';

const NewThreadPage = () => {
  const history = useHistory();
  const { courseId } = useParams();

  const onThreadCreated = useCallback(() => {
    history.push(`/${courseId}/forum`);
  }, [history, courseId]);

  const { onCreateThread, creatingThread } = useThreads({
    courseId,
    onThreadCreated,
  });

  const handleGoBack = useCallback(() => {
    history.push(`/${courseId}/forum`);
  }, [history, courseId]);

  return (
    <>
      <BackButton
        title={
          <FormattedMessage
            id="forum.createNewPost"
            defaultMessage="Crear Post"
          />
        }
        subtitle={<FormattedMessage id="forum.title" defaultMessage="Foro" />}
        onGoBack={handleGoBack}
      />
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        maxWidth={{ md: '100%', lg: 800 }}
        margin="auto"
      >
        <NewThreadForm onSubmit={onCreateThread} submitting={creatingThread} />
      </Box>
    </>
  );
};

export default NewThreadPage;
